"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.withExperimentalBlocksTokens = withExperimentalBlocksTokens;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function withExperimentalBlocksTokens(theme) {
    return _objectSpread({}, theme, {
        experimentalBlocks: {
            buttonVariant: undefined,
            backgroundColor: {
                base: theme.backgroundColor.base,
                disabled: theme.backgroundColor.disabled,
                clickNeutral: theme.backgroundColor.clickNeutral,
                clickSoft: theme.backgroundColor.clickSoft,
                brand: theme.backgroundColor.brand,
                danger: theme.backgroundColor.danger,
                neutral: theme.backgroundColor.neutral,
                interactive: theme.backgroundColor.interactive
            },
            font: {
                color: {
                    base: theme.font.color.base,
                    soft: theme.font.color.soft,
                    danger: theme.font.color.danger,
                    neutral: theme.font.color.neutral,
                    disabled: theme.font.color.disabled,
                    interactive: theme.font.color.interactive,
                    fill: theme.font.color.fill
                }
            },
            borderColor: {
                soft: theme.borderColor.soft,
                brand: theme.borderColor.brand,
                accent: theme.borderColor.accent
            }
        }
    });
}
function _withWackyExperimentalBlocksTokens(theme) {
    return _objectSpread({}, theme, {
        experimentalBlocks: {
            buttonVariant: 'neutral-white',
            backgroundColor: {
                base: 'red',
                disabled: theme.backgroundColor.disabled,
                clickNeutral: theme.backgroundColor.clickNeutral,
                clickSoft: theme.backgroundColor.clickSoft,
                brand: theme.backgroundColor.brand,
                danger: theme.backgroundColor.danger,
                neutral: _objectSpread({}, theme.backgroundColor.neutral, {
                    fill: _objectSpread({}, theme.backgroundColor.neutral.fill, {
                        surface: 'pink'
                    })
                }),
                interactive: _objectSpread({}, theme.backgroundColor.interactive, {
                    fill: _objectSpread({}, theme.backgroundColor.interactive.fill, {
                        base: 'yellow'
                    })
                })
            },
            font: {
                color: {
                    base: 'yellow',
                    soft: 'blue',
                    danger: theme.font.color.danger,
                    neutral: theme.font.color.neutral,
                    disabled: 'greenyellow',
                    interactive: theme.font.color.interactive,
                    fill: 'green'
                }
            },
            borderColor: {
                soft: theme.borderColor.soft,
                brand: _objectSpread({}, theme.borderColor.brand, {
                    focus: 'pink'
                }),
                accent: _objectSpread({}, theme.borderColor.accent, {
                    focus: 'purple'
                })
            }
        }
    });
}
